import { observer } from "mobx-react-lite";
import { ChevronRight } from "lucide-react";
import { useTran } from "@/hooks";
import { dashboardEChartsStore } from "../../../stores/e-charts.store";
import { buildBreadcrumbCopy } from "../../../utils/e-charts-view";

// Drill trail above the hero (R09 item 5). Back is a real button, not a
// clickable span, so the drill has a keyboard and screen-reader way out even
// though the way in is an SVG bar (brief 3.2 item 14). The drill comes from
// the panel, not the store: while a refetch is pending it is the drill of
// the view the ROWS answer, so the trail appears and disappears together
// with the data swap, never ahead of it.
const EChartsDrillBreadcrumb = observer(({ drillContext }) => {
  const { t } = useTran();
  const store = dashboardEChartsStore;
  const trail = buildBreadcrumbCopy({ drillContext });
  if (!trail) return null;

  return (
    <nav
      aria-label={t("Drill trail")}
      className="flex items-center gap-1 text-xs text-muted-foreground"
    >
      <button
        type="button"
        onClick={store.exitDrill}
        className="rounded-sm px-1 py-0.5 underline-offset-2 hover:text-foreground hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        {t(trail.backLabel.key)}
      </button>
      <ChevronRight className="h-3 w-3 shrink-0" aria-hidden="true" />
      <span className="font-bold text-foreground" aria-current="page">
        {trail.currentLabel}
      </span>
    </nav>
  );
});

export default EChartsDrillBreadcrumb;
